import { Settings } from "lucide-react";
import { RecordsIcon } from "./assets/records-icon";
import { Tooltip } from "../ui/modal";
import { useTranslation } from "react-i18next";

interface CreationHeaderProps {
  operationPlatformButton?: React.ReactNode;
  loading?: boolean;
  onOpenRecords?: () => void;
  onOpenDetail?: () => void;
}

export const CreationHeader = ({
  operationPlatformButton,
  loading,
  onOpenRecords,
  onOpenDetail
}: CreationHeaderProps) => {
  const { t } = useTranslation();

  return (
    <header className="absolute top-0 right-0 z-50 h-16 max-w-max">
      <div className="flex items-start justify-end pt-4 px-8 h-14">
        <div className="flex flex-row gap-2 px-2">
          <div className="flex items-center rounded-md overflow-hidden gap-2">
            <Tooltip
              side="top"
              align="center"
              trigger={
                <button
                  className="flex items-center py-1 px-2 text-[rgba(16,24,40,1)] hover:bg-white rounded-md outline-none"
                  onClick={() => onOpenRecords?.()}
                >
                  <RecordsIcon className="w-5 h-5" />
                </button>
              }
              content={
                <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
                  <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
                    {t('agent_creation.generate_record')}
                  </span>
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-l-transparent border-r-transparent border-b-black"></div>
                </div>
              }
            />
            <Tooltip
              side="top"
              align="center"
              trigger={
                <button
                  className="flex items-center py-1 px-2 text-[rgba(16,24,40,1)] hover:bg-white rounded-md outline-none"
                  onClick={() => onOpenDetail?.()}
                >
                  <Settings className="w-5 h-5" />
                </button>
              }
              content={
                <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
                  <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
                    {t('agent_creation.subscribe_settings')}
                  </span>
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-l-transparent border-r-transparent border-b-black"></div>
                </div>
              }
            />
          </div>
          {operationPlatformButton}
        </div>
      </div>
    </header>
  );
};
